import { render, staticRenderFns } from "./bankakodu.vue?vue&type=template&id=a3743672&"
import script from "./bankakodu.vue?vue&type=script&lang=js&"
export * from "./bankakodu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports